import React, { useState } from "react";
import PropTypes from "prop-types";
import { ArrowLeft } from "../images/ArrowLeft";
import ImageWithLoader from "../../../../common/components/product/ImageKit";

export const StoreItemImage = ({
  item,
  color,
  image, setImage
}) => {
  return (
    <div className="storeItem-image__container !relative !flex !justify-center">
      <div className="overflow-hidden transition-transform w-[350px] h-[257px] flex items-center rounded-2xl">
        <ImageWithLoader
          src={item.images[image]}
          alt={item.name}
          loading="lazy"
          className="w-full object-cover"
        />
      </div>

      {/* Sliders */}
      <div className="absolute bottom-72 max-lg:-top-14 w-10/12 max-sm:w-full bg-transparent">
        <div className="flex flex-col justify-center items-center gap-3 w-full absolute max-sm:-top-[20px] max-lg:-top-40 bottom-0">
          <p className="font-thin text-[14px] text-white">Available Colors</p>
          <div className="flex gap-2 items-center transition-all">
            {color.map((val, i) => (
              <span
                key={i}
                style={{ backgroundColor: val}}
                className={`size-5 border-[2px] transition-all border-solid rounded-full ${
                  image === i ? "border-white" : "border-transparent"
                }`}
                onClick={() => setImage(i)}
              />
            ))}
          </div>
        </div>
        <div className="flex justify-between w-full">
          <button
            className={`z-[999] disabled:cursor-not-allowed w-max transition-opacity ${
              image === 0 ? "opacity-30" : "opacity-100"
            }`}
            disabled={image === 0}
            onClick={() => setImage(prev => prev -1)}
          >
            <ArrowLeft />
          </button>
          <button
            className={`w-max !-rotate-180 disabled:cursor-not-allowed transition-opacity ${
              image === color.length - 1
                ? "opacity-30"
                : "opacity-100"
            }`}
            disabled={image === color.length - 1}
            onClick={() => setImage(prev => prev + 1)}
          >
            <ArrowLeft />
          </button>
        </div>
      </div>
    </div>
  );
};

StoreItemImage.propTypes = {
  item: PropTypes.object,
  color:PropTypes.array,
  image:PropTypes.number,
  setImage:PropTypes.any
};
